import { protectedResources } from '../../authConfig';
import makeGetRequestAsync, { makePostRequestAsync } from '../Helpers/httpRequestHelpers';

const apiScopes = protectedResources.companyApi.scopes;
const baseUrl = protectedResources.companyApi.endpoint;

export interface PlaygroundModeStatus {
  isActive: boolean;
}

// PlaygroundModeController is [Route("api/Company/playground-mode")] — deliberately under
// "api/Company", not "api/Auth": this service's ingress whitelist doesn't include "api/Auth"
// in any environment (Feature #8075, PBI #8077).
const url = `${baseUrl}/api/Company/playground-mode`;

export async function getPlaygroundModeStatus(): Promise<PlaygroundModeStatus> {
  const response = await makeGetRequestAsync<PlaygroundModeStatus>(apiScopes, url);
  return response.data;
}

export async function turnPlaygroundModeOn(): Promise<void> {
  await makePostRequestAsync<void, undefined>(apiScopes, `${url}/on`);
}

export async function turnPlaygroundModeOff(): Promise<void> {
  await makePostRequestAsync<void, undefined>(apiScopes, `${url}/off`);
}
